import { render, staticRenderFns } from "./PercoInfoView.vue?vue&type=template&id=4d1a16ca&scoped=true&"
import script from "./PercoInfoView.vue?vue&type=script&lang=js&"
export * from "./PercoInfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1a16ca",
  null
  
)

export default component.exports